import React from 'react'
import injectSheet from 'react-jss'
import styles from './details.styles'
import Segment from '../../../../shared/segment/segment'
import Segments from '../../../../shared/segments/segments'
import Description from '../../../../shared/description/description'
import Label from '../../../../shared/label/label'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import Button from 'pobble-components/dist/button'
import Tooltip from 'pobble-components/dist/tooltip'

const Details = ({
  classes,
  pending,
  title,
  urn,
  schoolId,
  userId,
  onRemove,
  isSchoolLeader
}) => (
  <div className={classes.container}>
    <Segments>
      <Segment>
        <Label>Your school name</Label>
        <span>{title}</span>
      </Segment>
      <Segment>
        <Label>Your school URN</Label>
        <span>{urn}</span>
      </Segment>
      <Segment>
        <Description>
          <p>
            This is your school, if something is wrong please contact us at{' '}
            <a href="mailto:hello@pobble.com">hello@pobble.com</a>.
          </p>
        </Description>
      </Segment>
    </Segments>
    {isSchoolLeader && (
      <div className={classes.leave}>
        <Tooltip
          content={
            "You can't leave this school as you are Admin. You can update this on the School's Team page."
          }>
          <Button short secondary disabled>
            I've left this school
          </Button>
        </Tooltip>
      </div>
    )}
    {!isSchoolLeader && (
      <div className={classes.leave}>
        <Button
          short
          secondary
          action={() =>
            openConfirmationDialog({
              bodyText: `Are you sure you want to leave your school? You will no longer be a teacher on Pobble until you join another school.`,
              confirmText: 'Yes',
              action: () => onRemove(schoolId, userId)
            })
          }>
          I've left this school
        </Button>
      </div>
    )}
  </div>
)

export default injectSheet(styles)(Details)
